export const ACCESS_TOKEN = process.env.REACT_APP_ACCESS_TOKEN;
export const CORE_API = process.env.REACT_APP_CORE_API;
export const DASHBOARD_API = process.env.REACT_APP_DASHBOARD_API_BASEPATH;
export const APP_SERVER_API = process.env.REACT_APP_APP_SERVER_API;

export const Colors = {
  green: "#0c9611",
  yellow: "#ffbc39",
  blue: "#54a9f1",
  red: "#F82F42",
  gray: "#94989B",
  purple: "#555EEA",
  white: "#FFF",
  black: "#000",
  lightGreen: "#d7ead3"
};

export const Languages = [
  { label: "English", value: "en" },
  { label: "हिंदी", value: "hi" },
  { label: "मराठी", value: "ma" },
  { label: "ಕನ್ನಡ", value: "ka" },
  { label: "ગુજરાતી", value: "gu" },
  {label: "తెలుగు", value: "te"},
  { label: "தமிழ்", value: "ta" }
];